import { useEffect, useState } from 'react';

import { useAnalytics } from '../useAnalytics';
import type { CycleTemplateListItem } from './models/CycleTypes';

export function useCycleTemplatesList(): {
	templates: CycleTemplateListItem[];
	defaultCycleTemplateID: string | null;
	loading: boolean;
} {
	const { requestCycleTemplates } = useAnalytics();

	const [templates, setTemplates] = useState<CycleTemplateListItem[] | null>(null);
	const [defaultCycleTemplateID, setDefaultCycleTemplateID] = useState<string | null>(null);

	useEffect(() => {
		let active = true;

		const request = () => {
			requestCycleTemplates()
				.then((data) => {
					if (!active) return;

					setTemplates(data.templates);
					setDefaultCycleTemplateID(data.defaultCycleTemplateID);
				})
				.catch(() => {
					// Worker restarted mid-request; retry against the new generation.
					if (active) request();
				});
		};

		request();

		return () => {
			active = false;
		};
	}, [requestCycleTemplates]);

	return { templates: templates ?? [], defaultCycleTemplateID, loading: templates === null };
}
